function CollapseDetails({ object, onDelete, onEdit }) {
  const suppliersAddress = `${object?.supplier?.region}, ${
    object?.supplier?.province || ""
  }, ${object?.supplier?.city}, ${object?.supplier?.barangay}`;
  return (
    <div className="d-flex flex-column gap-1">
      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">TIN :</label>
        <p className="m-0">{object?.supplier?.tinNo || "N/A"}</p>
      </div>

      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">VAT Value :</label>
        <p className="m-0"> &#8369; {object?.vat}</p>
      </div>

      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">Net Value :</label>
        <p className="m-0"> &#8369; {object?.net}</p>
      </div>

      {/* <div className="d-flex gap-2 mt-2">
        <button
          className="col-4 col-md-2 col-lg-1 text-center rounded-2 text-white"
          style={{ backgroundColor: "#14213D" }}
          onClick={() => onEdit(object)}
        >
          <i className="bi bi-pencil me-2"></i>
          Edit
        </button>
        <button
          className="btn btn-danger btn-md col-4 col-md-2 col-lg-1 text-center"
          style={{ backgroundColor: "#E63946" }}
          onClick={() => onDelete(object.id)}
        >
          <i className="bi bi-trash me-2"></i>
          Delete
        </button>
      </div> */}
    </div>
  );
}

export default CollapseDetails;
